import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DatePicker from 'components/sales/datePicker/datePicker';
import ErrModalPop from 'components/sales/modal/errorModal';
import moment from 'moment';
import parse from 'html-react-parser';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { Route, Redirect } from "react-router-dom";
import useLatLng from 'hooks/uselatlng/uselatlng';
import { toast } from 'react-toastify';
import {postUpdateRca} from "../../../services/redux/maintenance/rmTicket/action";
import './crCss.css';


const CloseRmTicket = ({
  fetchRmTicketDetails,
  rmTicketDetails,
  postUpdateRMStatus,
  documentUploadUrl,
  postRmRemark,
  match,
  fetchRmTicketStatus,
  getMaterial,
  rmStatus,
  materials,
  location,
  getEquipments,
  equipments,
  getSiteData,
  siteData,
  getDistanceData,
  distanceDetails,
  fetchRmTicketDetailsForUpdation,
  rmTicketDetailsForUpdation,
  postUpdateRca,
  generateHappyCode
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [assigneeId, setAssigneeId] = useState('');
  const [matData, setMatData] = useState();
  const [isRoleId, setIsRoleId] = useState([]);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [remarkData, setRemarkData] = useState({
    rm_ticket_id: match.params.id,
    status: match.params.status,
    delayed_due_to:'',
    reason_close:'',
    remarks: '',
    criticality: '',
    type_of_issue: '',
    mat_issued_by_store: '',
    scope:'',
    attachment: '',
    invoice_no:'',
    close_date:moment(new Date(), 'DD-MM-YYYY').format(
      'DD-MM-YYYY'
    ),
    old_actual_issue:'',
    solution:'',
    signed_by: '',
    designation: '',
    issue_related:'',
    payment_status:'',
    general_remarks: '',
    doc: '',
    otp: ''
  });

  const [addItem, setAddItem] = useState(1);
  const [componantData, setComponantData] = useState([]);
  const [level1Data, setLevel1Data] = useState([]);
  const [level2Data, setLevel2Data] = useState([]);
  const [level3Data, setLevel3Data] = useState([]);
  const [level4Data, setLevel4Data] = useState([]);
  const [level5Data, setLevel5Data] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [levelInput, setLevelInput] = useState([{equipment_id: '',issue_id: '',componant_id: '',level_1: '',level_2:'',level_3:'',level_4:'',level_5:'' ,remark_val:'',equipment_id_name: '',issue_id_name: '',componant_id_name: '',level_1_name: '',level_2_name:'',level_3_name:'',level_4_name:'',level_5_name:''}]);
  const [showRemark, setShowRemark] = useState(false);
  const [inputList, setInputList] = useState([{ material_id:"",make: "", return_to_store: "",faulty:"",repair:"" }]);
  const [successModal, setSuccessModal] = useState(false);
  const [siteId, setSiteId] = useState('');
  const islatlng = useLatLng();
  const [checkoutId, setCheckoutId] = useState('');
  const [isRca, setIsRca] = useState('no');
  const [rcaValue, setRcaValue] = useState('NO');
  const [isEdit, setIsEdit] = useState(0);
  const [isRcaEdit, setIsRcaEdit] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [ifFalseComplain, setIfFalseComplain] = useState(true);
  const [happyCodeCheck, setHappyCodeCheck] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles.map((obj) => isRoleId.push(obj.id));
        setIsRoleId(isRoleId);
      })();
    }, 1000);
  }, [isRoleId]);

  // handle input change
  const handleInputChange = (e, index) => {
    // console.log(e);
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  const handledropDownChange = (e, index,name) => {
    const { value,id} = e;
    const list = [...inputList];
    list[index][name] = id;
    setInputList(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleLevelRemoveClick = index => {
    const list = [...levelInput];
    list.splice(index, 1);
    setLevelInput(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { material_id:"",make: "", return_to_store: "",faulty:"",repair:"" }]);
  };

  const handleLevelAddClick = () => {
    setLevelInput([...levelInput, {equipment_id: '',issue_id: '',componant_id: '',level_1: '',level_2:'',level_3:'',level_4:'',level_5:'',remark_val:'',equipment_id_name: '',issue_id_name: '',componant_id_name: '',level_1_name: '',level_2_name:'',level_3_name:'',level_4_name:'',level_5_name:''}]);
  };

  const handleFormData = () => {
    if (inputList) {
      setRemarkData({
        ...remarkData,
        materials : inputList,
      });
    } else {

    }
  };

  const saveImage = (val) => {
    setRemarkData({ ...remarkData, doc: val });
  };

  useEffect(() => {
    handleFormData();
  }, [inputList]);

  const handleModalHide = () => setIsModal(false);

  const handleRcaShow = (v) => {
     if(v.id != '') {
       console.log(v);
       setIsRca(v.id);
       setRcaValue(v.value);
     }
  }

  const handleInputLevel = (val, key,index) => {
    const list = [...levelInput];
    if(key == 'remark_val') {
      list[index][key] = val;
    } else {
      list[index][key] = val.id;
      list[index][key+'_name'] = val.value;
    }
    setLevelInput([...list]);
    setCurrentIndex(index);
  };

  const headerBtns = () => {
    return (
      <Fragment>


      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
      if (fetchRmTicketDetails) {
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        await fetchRmTicketStatus();
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketDetails]);

  useEffect(() => {
    (async () => {
      if (fetchRmTicketDetailsForUpdation) {
        setIsLoading(true);
        await fetchRmTicketDetailsForUpdation(match.params.id);
        await fetchRmTicketStatus();
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketDetailsForUpdation]);

  useEffect(() => {
    (async () => {
      if (getMaterial) {
        setIsLoading(true);
        await getMaterial(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [getMaterial]);

  useEffect(() => {
    (async () => {
      if (getEquipments) {
        setIsLoading(true);
        await getEquipments();
        setIsLoading(false);
      }
    })();
  }, [getEquipments]);

  const handleEquipmentChange = async (id,index) => {
    if(id){
     try {
       const level = [...levelInput];
       level[index]['level_1'] = '';
       level[index]['level_1_name'] = '';
       level[index]['level_2'] = '';
       level[index]['level_2_name'] = '';
       level[index]['level_3'] = '';
       level[index]['level_3_name'] = '';
       level[index]['level_4'] = '';
       level[index]['level_4_name'] = '';
       level[index]['level_5'] = '';
       level[index]['level_5_name'] = '';
       level[index]['issue_id'] = '';
       level[index]['issue_id_name'] = '';
       level[index]['componant_id'] = '';
       level[index]['componant_id_name'] = '';
       level[index]['remark_val'] = '';

       const url = `${Config.maintenance.getComponants}?id=${id}`;
       const { data } = await axios.get(url);
       const list = [...componantData];
       list[index] = data?.response?.data;
       setComponantData([...list]);
     } catch {
       //toast.error('Something went wrong, Please try again')
     }
    }
   };

   const handleTargetLevels = async (key,index) => {
    try {
      const level = [...levelInput];
      if(key == 'issue') {
        level[index]['componant_id'] = '';
        level[index]['componant_id_name'] = '';
      }
      level[index]['level_1'] = '';
      level[index]['level_1_name'] = '';
      level[index]['level_2'] = '';
      level[index]['level_2_name'] = '';
      level[index]['level_3'] = '';
      level[index]['level_3_name'] = '';
      level[index]['level_4'] = '';
      level[index]['level_4_name'] = '';
      level[index]['level_5'] = '';
      level[index]['level_5_name'] = '';
      level[index]['remark_val'] = '';
    } catch {
      console.log('Levels Not Clear..');
    }
   }

   const handleLevelChange = async (id,key,index) => {
    if(id){
     try {
      if(key == 'l1') {
        const payload = {
          'componant_id': levelInput[index]['componant_id'],
          'issue_id': levelInput[index]['issue_id']
         }
         const url = `${Config.maintenance.getLevels}`;
         const { data } = await axios.post(url,payload);
         const list = [...level1Data];
         list[index] = data?.response?.data;
         setLevel1Data([...list]);
      } else if(key == 'l2') {
        const level = [...levelInput];
        level[index]['level_2'] = '';
        level[index]['level_2_name'] = '';
        level[index]['level_3'] = '';
        level[index]['level_3_name'] = '';
        level[index]['level_4'] = '';
        level[index]['level_4_name'] = '';
        level[index]['level_5'] = '';
        level[index]['level_5_name'] = '';
        const payload = {
          'componant_id': levelInput[index]['componant_id'],
          'issue_id': levelInput[index]['issue_id'],
          'level_1': id
         }
         console.log(payload);
         const url = `${Config.maintenance.getLevelsDropdown}`;
         const { data } = await axios.post(url,payload);
         const list = [...level2Data];
         list[index] = data?.response?.data;
         setLevel2Data([...list]);

      } else if(key == 'l3') {
        const level = [...levelInput];
        level[index]['level_3'] = '';
        level[index]['level_3_name'] = '';
        level[index]['level_4'] = '';
        level[index]['level_4_name'] = '';
        level[index]['level_5'] = '';
        level[index]['level_5_name'] = '';
        const payload = {
          'componant_id': levelInput[index]['componant_id'],
          'issue_id': levelInput[index]['issue_id'],
          'level_2': id
         }
         console.log(payload);
         const url = `${Config.maintenance.getLevelsDropdown}`;
         const { data } = await axios.post(url,payload);
         const list = [...level3Data];
         list[index] = data?.response?.data;
         setLevel3Data([...list]);

      } else if(key == 'l4') {
        const level = [...levelInput];
        level[index]['level_4'] = '';
        level[index]['level_4_name'] = '';
        level[index]['level_5'] = '';
        level[index]['level_5_name'] = '';
        const payload = {
          'componant_id': levelInput[index]['componant_id'],
          'issue_id': levelInput[index]['issue_id'],
          'level_3': id
         }
         console.log(payload);
         const url = `${Config.maintenance.getLevelsDropdown}`;
         const { data } = await axios.post(url,payload);
         const list = [...level4Data];
         list[index] = data?.response?.data;
         setLevel4Data([...list]);

      } else if(key == 'l5') {
        const level = [...levelInput];
        level[index]['level_5'] = '';
        level[index]['level_5_name'] = '';
        const payload = {
          'componant_id': levelInput[index]['componant_id'],
          'issue_id': levelInput[index]['issue_id'],
          'level_4': id
         }
         console.log(payload);
         const url = `${Config.maintenance.getLevelsDropdown}`;
         const { data } = await axios.post(url,payload);
         const list = [...level5Data];
         list[index] = data?.response?.data;
         setLevel5Data([...list]);
      } else {
        console.log('level not found..');
      }

     } catch {
       //toast.error('Something went wrong, Please try again')
     }
    }
   };

   useEffect( () => {
    (async () => {
      if(rmTicketDetails !== null && rmTicketDetails.complains != null && Object.keys(rmTicketDetails.complains).length > 0){
        setIsLoading(true)
        if(rmTicketDetails.complains['site_id'] !== undefined){
          await getDistanceData(rmTicketDetails.complains['site_id'], 'RM')
        }
        setSiteId(rmTicketDetails.complains['site_id']);
        setTableData(rmTicketDetails?.rm_level_data);
        setIsLoading(false)
        if(rmTicketDetails.complains['source'] !== undefined && rmTicketDetails.complains['source'] !== "" && (rmTicketDetails.complains['source'] == 'pm_hardware' || rmTicketDetails.complains['source'] == 'pm_software')) {
          setHappyCodeCheck(false);
      }
      if(rmTicketDetails !== null && rmTicketDetails?.ticket != null && (rmTicketDetails.complains['source'] !== 'pm_hardware' && rmTicketDetails.complains['source'] !== 'pm_software')){ 
          if(rmTicketDetails?.ticket?.happy_code == null && match.params.status == 3) {
              const otpStatus = await generateHappyCode(match.params.status,match.params.id);
              if(otpStatus) {
                   toast.success('OTP sent');
              }
          }
      }
      }
      
    })()
  }, [rmTicketDetails])

  useEffect( () => {
    if (rmTicketDetailsForUpdation?.rm_close_data !== null && rmTicketDetailsForUpdation?.rm_close_data !== undefined) {
      if (rmTicketDetailsForUpdation?.rm_close_data?.eng_remarks !== null && rmTicketDetailsForUpdation?.rm_close_data?.eng_remarks !== undefined) {
        const {
          id,
          delayed_due_to,
          remarks,
          scope,
          reason_close,
          gen_remarks,
          document,
          rm_ticket_id
        } = rmTicketDetailsForUpdation?.rm_close_data?.eng_remarks;
        setRemarkData({
          delayed_due_to: delayed_due_to,
          remarks: remarks,
          scope: scope,
          reason_close: reason_close,
          general_remarks: gen_remarks,
          doc: document,
          rm_ticket_id: rm_ticket_id
        });
      }
      setIsEdit(1);
      if (rmTicketDetailsForUpdation?.rm_level_data !== null && rmTicketDetailsForUpdation?.rm_level_data !== undefined) {
        // handleInputLevel(val, 'equipment_id',i);
        // rmTicketDetailsForUpdation?.rm_level_data.map((x, i) => {
        //   console.log(x);
          // handleEquipmentChange(x.equipment_id,i);
          // handleInputLevel({id: x.equipment_id, value: x.equipment_id_name}, 'equipment_id',i);
          // handleInputLevel({id: x.componant_id, value: x.componant_id_name}, 'component_id',i);
          // handleInputLevel({id: x.issue_id, value: x.issue_id_name}, 'issue_id',i);
          // if (x?.)
        // });
        setIsRcaEdit(1);
        //setLevelInput(rmTicketDetailsForUpdation?.rm_level_data);
        setIsRca('no');
        setRcaValue('No');
      }
    }
  }, [rmTicketDetailsForUpdation])

  useEffect(() => {
     if(distanceDetails != null) {
        setCheckoutId(distanceDetails?.id);
     }
  },[distanceDetails]);

  useEffect(() => {
    if(siteId) {
      (async () => {
          await getSiteData(siteId)
      })();
    }
  }, [siteId, getSiteData]);
  //console.log(siteData);

  const toRad = (Value) => {
    return Value * Math.PI / 180
  }

  const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371 // km
    var dLat = toRad(lat2 - lat1)
    var dLon = toRad(lon2 - lon1)
    var lat1 = toRad(lat1)
    var lat2 = toRad(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d
  }

  const saveReply = async () => {
     //console.log(remarkData); return false;
    setIsLoading(true);
    if(match.params.status == 3){
      if(happyCodeCheck) {
        if(remarkData.otp == '' || remarkData.otp.length != 6) {
            toast.error('Please enter 6 digit valid OTP');
            setIsLoading(false);
            return false;
        }
      }
      if (remarkData.delayed_due_to !== '' && remarkData.reason_close !== '' && remarkData.scope !== '' && remarkData.general_remarks !== '' && remarkData.doc !== '' ) {
        if(isRca == 'no') {
          for (let i = 0; i < levelInput.length; i++) {
            if(levelInput[i]['equipment_id'] == '' || levelInput[i]['componant_id'] == '' || levelInput[i]['issue_id'] == '' || levelInput[i]['remark_val'] == '') {
              var errMsg = 'Please Select Mandatory Fields!';
              setIsErrorMsg(errMsg);
              setIsErrorModal(true);
              setIsLoading(false);
              return false;
            }
          }
        }
        remarkData['levels'] = levelInput;
        remarkData['false_complaint'] = isRca;
         //Auto Checkout Data
        if (!isEdit) {
           const checkout_lat = Number(islatlng?.lat);
           const checkout_long = Number(islatlng?.lng);
           if(isNaN(checkout_lat) || isNaN(checkout_long)) {
             alert(localization.locationPermission);
             return false;
           } else {
             var checkout_distance = calcCrow(checkout_lat, checkout_long, siteData['lead']['latitude'], siteData['lead']['longitude']);
             if(isNaN(checkout_distance) || checkout_distance == null || checkout_distance == undefined) {
               console.log('some issue occur in calculating distance between user location and site location.');
               toast.error('Distance Not Fetched.');
               return false;
             }
           }
           remarkData['checkout'] = {
             'id':checkoutId,
             'checkout_lat':checkout_lat,
             'checkout_long':checkout_long,
             'checkout_distance_in_km': checkout_distance,
             'checkout_remark':'',
           }
          const res = await postUpdateRMStatus(remarkData);
          if (res === true) {
            setSuccessModal(true);
          }
          setIsLoading(false);
        } else {
          const res = await postUpdateRca(remarkData);
          if (res === true) {
            setSuccessModal(true);
          }
          setIsLoading(false);
        }

      }else{
        if(remarkData.doc ===''){
          var errMsg = 'Please upload document!<br/>';
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          setIsLoading(false);
        }else{
          var errMsg = 'Please Select Mandatory Fields!';
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          setIsLoading(false);
        }

      }
    }else{
      if (remarkData.type_of_issue !== '') {
        var CHECKERR = 0;
        var errMsg = '';
        if(ifFalseComplain == true && (remarkData.close_date == '' || remarkData.criticality == '' || remarkData.delayed_due_to == '' || remarkData.designation == '' || remarkData.issue_related == '' || remarkData.mat_issued_by_store == '' || remarkData.old_actual_issue == '' || remarkData.payment_status == '' || remarkData.scope == '' || remarkData.signed_by == ''))
        { 
          CHECKERR = 1;
          errMsg = 'Please Select Mandatory Fields!';
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          setIsLoading(false);
        }  
        if(remarkData.material_required ==='Yes'){
          inputList && inputList.map((getData)=>{
            if(getData.material_id === ''){
              errMsg = errMsg+'Please Select Material!<br/>';
              CHECKERR = 1;
            }
            if(getData.faulty === ''){
              errMsg = errMsg+'Please Select Faulty!<br/>';
              CHECKERR = 1;
            }
            if(getData.repair === ''){
              errMsg = errMsg+'Please Select Repair!<br/>';
              CHECKERR = 1;
            }
            if(getData.return_to_store === ''){
              errMsg = errMsg+'Please Select Return to store!<br/>';
              CHECKERR = 1;
            }
            //console.log(getData)
          });
        }

        if(CHECKERR == 0){
          const res = await postUpdateRMStatus(remarkData);
          if (res === true) {
            setSuccessModal(true);
          }
          setIsLoading(false);
        }else{
          setIsErrorMsg(errMsg);
          setIsErrorModal(true);
          setIsLoading(false);
        }

      }else{
        var errMsg = 'Please Select Mandatory Fields!';
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        setIsLoading(false);
      }
    }

  };

  useEffect(() => {
    (() => {
      if (successModal === true) {
        setRemarkData({
          rm_ticket_id: match.params.id,
          remarks: '',
          attachment: '',
        });
      }
    })();
  }, [successModal]);

  // const updatePMStatus = async () => {
  //   const data = {
  //     rm_ticket_id: match.params.id,
  //     status: assigneeId,
  //   };
  //   if (assigneeId != '') {
  //     const res = await postUpdateRMStatus(data);
  //     if (res === true) {
  //       setIsModal(false);
  //       setIsLoading(true);
  //       await fetchRmTicketDetails(match.params.id);
  //       setIsLoading(false);
  //     }
  //   }
  // };

  const handleRemoveRca = async (id) => {
     if(id) {
       setIsLoading(true);
       const url = `${Config.maintenance.removeRcaItem}?id=${id}`;
       const { data } = await axios.post(url);
       if(data && data.response.data == true) {
         await fetchRmTicketDetails(match.params.id);
         await fetchRmTicketStatus();
       } else {
          toast.error('RCA not deleted successfully.');
       }
       setIsLoading(false);
     }
  }

  const handleModalHide1 = () => setIsErrorModal(false);

  const handleComplain = (id) => {
    if(id === 'False complaint') {
       setIfFalseComplain(false);
    } else {
       setIfFalseComplain(true);
    }
  }

  const resendOTP = () => {
    (async () => {
          setIsLoading(true);
          if(match.params.id !== undefined && match.params.status == 3) {
              const otpStatus = await generateHappyCode(match.params.status,match.params.id);
              if(otpStatus) {
                   setIsLoading(false);
                   toast.success('OTP sent');

              }
          }
          setIsLoading(false);
    })()
  }

  return (
    <Layout
      title={localization.ticketDetails}
      Buttons={!match.path.includes('rm-view/') ? headerBtns : () => {}}
      isLoading={isLoading}
      isGoback
      linkUrl={
        match.path.includes('rm-view/')
          ? `${baseUrl}/approvals/rm-tickets`
          : `${baseUrl}/rm-tickets`
      }
    >
      { match.params.status != 5 && tableData && tableData.length > 0 ? (
      <CardSection title={'Filled RCA'}>
      <>
      <table className="panel-table table table-bordered">
            <thead>
                <tr>
                   <th>S.No</th> 
                   <th>Equipment</th> 
                   <th>Issue</th> 
                   <th>Componant</th> 
                   <th>Level 1</th>
                   <th>Level 2</th>
                   <th>Level 3</th>
                   <th>Level 4</th>
                   <th>Level 5</th>
                   <th>Remark</th> 
                   <th className='text-center'>Action</th> 
                </tr>
            </thead>
            <tbody>
            {tableData.map((item, x) => 
              <tr key={x}>
                <td>{x+1}</td>
                <td>{item.equipment}</td>
                <td>{item.issue}</td>
                <td>{item.componant}</td>
                <td>{item.level_1 ? item.level_1 : 'NA'}</td>
                <td>{item.level_2 ? item.level_2 : 'NA'}</td>
                <td>{item.level_3 ? item.level_3 : 'NA'}</td>
                <td>{item.level_4 ? item.level_4 : 'NA'}</td>
                <td>{item.level_5 ? item.level_5 : 'NA'}</td>
                <td>{item.remark_val}</td>
                <td><a onClick={() => handleRemoveRca(item.id)} className='btn btn-sm btn-danger'>Remove</a></td>
              </tr>
            )}  
            </tbody>
          </table>
          </>
          </CardSection>
          ):null}
          <br />
      {rmTicketDetails.ticket && rmTicketDetails.ticket.status_code !== 5  ? (
        <CardSection title={match.params.status == 5 ?'Complete RM Ticket':'Short Close RM Ticket'}>
          <form>
          <div className="form-group full-width">
            <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Payment pending from client side', name: 'Payment pending from client side' },
                  { id: 'Client Dependency', name: 'Client Dependency' },
                  { id: 'Backend Support required', name: 'Backend Support required' },
                  { id: 'Material support required', name: 'Material support required' },
                  { id: 'Internet', name: 'Internet' },
                  { id: 'No Delay', name: 'No Delay' },
                  { id: 'Others', name: 'Others' },
                ]}
                label='Delayed Due to'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    delayed_due_to: val.id,
                  });
                }}
                value={remarkData?.delayed_due_to}
                isStarRequired={true}
              />
           </div>
           <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Remarks( Running Commentary with reason)'
                type="text"
                value={remarkData.remarks}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, remarks: val })
                }
              />
            </div>
            {match.params.status == 5 ?
            <>
              <div className="col-md-6 col-sm-12 col-xs-12">
                <DropDownInput
                  data={[
                    { id: 'Low', name: 'Low' },
                    { id: 'Medium', name: 'Medium' },
                    { id: 'High', name: 'High' },
                  ]}
                  label='Criticality'
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setRemarkData({
                      ...remarkData,
                      criticality: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>


            <div className="col-md-6 col-sm-12 col-xs-12">
                <DropDownInput
                  data={[
                    { id: 'Tech', name: 'Tech' },
                    { id: 'Hardware', name: 'Hardware' },
                    { id: 'POS device', name: 'POS device' },
                    { id: 'Tag Issue', name: 'Tag Issue' },
                    { id: 'False complaint', name: 'False complaint' },
                    { id: 'Internet', name: 'Internet' },
                    { id: 'New Request', name: 'New Request' },


                  ]}
                  label='Type of issues '
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setRemarkData({
                      ...remarkData,
                      type_of_issue: val.id,
                    });
                    handleComplain(val.id);
                  }}
                  isStarRequired={true}
                />
            </div>

          {ifFalseComplain ? (
          <>
           <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Yes', name: 'Yes' },
                  { id: 'No', name: 'No' },
                ]}
                label='Material issued by store'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    mat_issued_by_store: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>

           <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Park Plus', name: 'Park Plus' },
                  { id: 'Client', name: 'Client' },
                ]}
                label='Scope of material'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    scope: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>

           {/* Invoice No */}
           <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Invoice No'
                type="text"
                value={remarkData.invoice_no}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, invoice_no: val })
                }
                // isStarRequired={true}
              />
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <DatePicker
                // handleChange={(val) => {
                //   setRemarkData({ ...remarkData, close_date: val });
                // }}
                value={moment(new Date(), 'DD-MM-YYYY').format(
                  'DD-MM-YYYY'
                )}
                displayFormat="DD-MM-YYYY"
                returnFormat="DD-MM-YYYY"
                label='Select Close Date'
                // isStarRequired={true}
                disabled={true}
                // minimumDate={new Date()}
              />
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Old Actual Issue'
                type="text"
                value={remarkData.old_actual_issue}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, old_actual_issue: val })
                }
                isStarRequired={true}
              />
            </div>
            {/* Solution provided / RCA */}
            <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Solution provided / RCA'
                type="text"
                value={remarkData.solution}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, solution: val })
                }
                isStarRequired={true}
              />
            </div>
            {/* Report signed by */}
            <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Report signed by'
                type="text"
                value={remarkData.signed_by}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, signed_by: val })
                }
                isStarRequired={true}
              />
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Caretaker', name: 'Caretaker' },
                  { id: 'President', name: 'President' },
                  { id: 'Vice president', name: 'Vice president' },
                  { id: 'Treasure', name: 'Treasure' },
                  { id: 'Security Incharge', name: 'Security Incharge' },
                  { id: 'RWA official', name: 'RWA official' },
                  { id: 'Estate Manager', name: 'Estate Manager' },
                  { id: 'Office Admin', name: 'Office Admin' },

                ]}
                label='Designation'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    designation: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>
           <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Arm Alingment', name: 'Arm Alingment' },
                  { id: 'Arm Damaged', name: 'Arm Damaged' },
                  { id: 'Backend Dependency', name: 'Backend Dependency' },
                  { id: 'Control Card Parameter Setting issue', name: 'Control Card Parameter Setting issue' },
                  { id: 'Limit switch not taking position', name: 'Limit switch not taking position' },
                  { id: 'Encoder not working', name: 'Encoder not working' },
                  { id: 'Motor Getting stuck', name: 'Motor Getting stuck' },
                  { id: 'Motor Resistance high that’s why barrier not working', name: 'Motor Resistance high that’s why barrier not working' },
                  { id: 'Unbalanced boom arm', name: 'Unbalanced boom arm' },
                  { id: 'Play in Gear box', name: 'Play in Gear box' },
                  { id: 'Assembly Damaged', name: 'Assembly Damaged' },
                  { id: 'Improper spring arrangement', name: 'Improper spring arrangement' },
                  { id: 'Barrier Canopy Damaged', name: 'Barrier Canopy Damaged' },
                  { id: 'Barrier canopy lock damaged', name: 'Barrier canopy lock damaged' },
                  { id: 'Boom Housing', name: 'Boom Housing' },
                  { id: 'Barrier Auto/Manual key issue', name: 'Barrier Auto/Manual key issue' },
                  { id: 'Control card connector issue', name: 'Control card connector issue' },
                  { id: 'Remote Receiver issue', name: 'Remote Receiver issue' },
                  { id: 'Remote configuration issue', name: 'Remote configuration issue' },
                  { id: 'Barrier control wiring', name: 'Barrier control wiring' },
                  { id: 'Remote Receiver issue', name: 'Remote Receiver issue' },
                  { id: 'Barrier 24 V SMPS', name: 'Barrier 24 V SMPS' },
                  { id: 'Civil Work', name: 'Civil Work' },
                  { id: 'Internet', name: 'Internet' },
                  { id: 'LED power supply', name: 'LED power supply' },
                  { id: 'LED Indicator', name: 'LED Indicator' },
                  { id: 'Magnatic Loop', name: 'Magnatic Loop' },
                  { id: 'Pi power supply', name: 'Pi power supply' },
                  { id: 'Photocell', name: 'Photocell' },
                  { id: 'POS Device', name: 'POS Device' },
                  { id: 'POS Device Charger', name: 'POS Device Charger' },
                  { id: 'Push Button', name: 'Push Button' },
                  { id: 'POS Device Battery', name: 'POS Device Battery' },
                  { id: 'Respbri PI', name: 'Respbri PI' },
                  { id: 'Respbri PI power Connector', name: 'Respbri PI power Connector' },
                  { id: 'Reader Power Adaptor', name: 'Reader Power Adaptor' },
                  { id: 'Reader RJ-45 Connector', name: 'Reader RJ-45 Connector' },
                  { id: 'Reader Range', name: 'Reader Range' },
                  { id: 'Remote Issue', name: 'Remote Issue' },
                  { id: 'Remote Battery', name: 'Remote Battery' },
                  { id: 'SD Card', name: 'SD Card' },
                  { id: 'Software (Code Related issue)', name: 'Software (Code Related issue)' },
                  { id: 'Spring', name: 'Spring' },
                  { id: 'Server', name: 'Server' },
                  { id: 'Traffic Light', name: 'Traffic Light' },
                  { id: 'Tag', name: 'Tag' },
                  { id: 'UPS', name: 'UPS' },
                  { id: 'Wirring', name: 'Wirring' },

                  { id: 'Anpr', name: 'Anpr' },
                  { id: 'Router', name: 'Router' },
                  { id: '12/5 supply card', name: '12/5 supply card' },
                  { id: 'power supply', name: 'power supply' },
                  { id: 'civil damage', name: 'civil damage' },
                  { id: 'Loop detector issue', name: 'Loop detector issue' },
                  { id: 'Anpr alignment', name: 'Anpr alignment' },
                  { id: 'LPU/RP5 SD card', name: 'LPU/RP5 SD card' },
                  { id: 'Lpu', name: 'Lpu' },
                  { id: 'boom arm repairing', name: 'boom arm repairing' },
                  { id: 'Panel', name: 'Panel' },
                  { id: 'panel lock faulty', name: 'panel lock faulty' },
                  { id: 'Water logging issue', name: 'Water logging issue' },
                  { id: 'LED issue', name: 'LED issue' },
                  { id: 'LED configuration', name: 'LED configuration' },
                  { id: 'orange pi faulty', name: 'orange pi faulty' },
                  { id: 'TVM Issue', name: 'TVM Issue' },
                  { id: 'TVM printer issue', name: 'TVM printer issue' },
                  { id: 'TVM printer cable faulty', name: 'TVM printer cable faulty' },
                  { id: 'Reader alignment', name: 'Reader alignment' },
                ]}
                label='Issue Related'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    issue_related: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>

           <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Done', name: 'Done' },
                  { id: 'Pending', name: 'Pending' },
                  { id: 'N/A', name: 'N/A' },
                ]}
                label='Payments status'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    payment_status: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>
           <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Yes', name: 'Yes' },
                  { id: 'No', name: 'NO' },
                ]}
                label='Material Required'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    material_required: val.id,
                  });
                }}
                isStarRequired={true}
              />
           </div>
            {/* MAterials */}
            {remarkData && remarkData.material_required === 'Yes' ?
            <>
             {inputList.map((x, i) => {
                return (
                  <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12">
                    <DropDownInput
                    data={materials}
                    label='Material'
                    required
                    isStarRequired={true}
                    errorMsg={localization.tags}
                    getIdValue={(val) =>{
                      setMatData({
                        ...matData,
                        material_id: val.id,
                      });
                      handledropDownChange(val,i,'material_id');
                    }
                    }
                    value={x.tag_name}
                    // onChange={e => handleInputChange(e, i)}
                  />

                    </div>

                    <div className="col-md-6 col-sm-12 col-xs-12">
                    <input
                      className="form-control"
                      name="make"
                      placeholder="Make"
                      value={x.make}
                      onChange={e => handleInputChange(e, i)}
                    />
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                          label='Marerial return to store'
                          data={[
                            { id: 'Yes', name: 'Yes' },
                            { id: 'No', name: 'No' },
                          ]}
                          required
                          errorMsg='Marerial return to store'
                          getIdValue={(val) =>{
                            setMatData({
                              ...matData,
                              return_to_store: val.id,
                            });
                            handledropDownChange(val,i,'return_to_store');
                          }
                          }
                          value={x.return_to_store}
                          isStarRequired={true}
                      />

                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                          label='Faulty material'
                          data={[
                            { id: 'Yes', name: 'Yes' },
                            { id: 'No', name: 'No' },
                          ]}
                          required
                          errorMsg='Faulty material'
                          getIdValue={(val) =>{
                            setMatData({
                              ...matData,
                              faulty: val.id,
                            });
                            handledropDownChange(val,i,'faulty');
                          }
                          }
                          value={x.faulty}
                          isStarRequired={true}
                      />

                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                          label='Repair /Replacements'
                          data={[
                            { id: 'Repair', name: 'Repair' },
                            { id: 'Replacements', name: 'Replacements' },
                          ]}
                          required
                          errorMsg='Repair /Replacements'
                          getIdValue={(val) =>{
                            setMatData({
                              ...matData,
                              repair: val.id,
                            });
                            handledropDownChange(val,i,'repair');
                          }
                          }
                          value={x.repair}
                          isStarRequired={true}
                      />

                    </div>

                    {/* <div className="btn-box"> */}
                      {inputList.length !== 1 &&
                      <div className="col-md-3 col-sm-5 col-xs-6">
                         <button
                          onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger">Remove</button>
                        </div>
                        }
                      {inputList.length - 1 === i &&
                      <div className="col-md-3 col-sm-5 col-xs-6">
                      <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>
                      </div>
                      }
                    {/* </div> */}
                    <hr/>
                  </div>

                );
              })}
            </>
            :
            null
            }
            </>
          ):null}

              {/* END MATERIAL */}

            </>
            :
            <>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'Park Plus', name: 'Park Plus' },
                  { id: 'Client', name: 'Client' },
                ]}
                label='Scope of material'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setRemarkData({
                    ...remarkData,
                    scope: val.id,
                  });
                }}
                value={remarkData.scope}
                isStarRequired={true}
              />
           </div>
           <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Reason of short close'
                type="text"
                value={remarkData.reason_close}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, reason_close: val })
                }
              />
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <ConstantInput
                label='Remarks'
                type="text"
                value={remarkData.general_remarks}
                handleChange={(val) =>
                  setRemarkData({ ...remarkData, general_remarks: val })
                }
                required
                errorMsg={localization.requiredErrorMg}
                isStarRequired={true}
              />

            </div>

            <div className="col-md-6 col-sm-12 col-xs-12">
              <FileUpload
                id="agreementContractUpload"
                accept=".pdf,.png,.jpg"
                documentUploadUrl={documentUploadUrl}
                onChange={(val) => saveImage(val)}
                prefilledFilename={remarkData?.doc}
              >
                <span className="btn btn-transparent">
                  {localization.uploadDocs} <span style={{color:'red'}}>*</span>
                </span>
              </FileUpload>
            </div>
            </>
            }

            {/* Is RCA */}
            {match.params.status == 3 ? (
            <>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <DropDownInput
                data={[
                  { id: 'yes', name: 'Yes' },
                  { id: 'no', name: 'No' },
                ]}
                label='False Complaint'
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  handleRcaShow(val);
                }}
                value={rcaValue}
                isStarRequired={true}
              />
           </div>
           </>
           ):null}

            {/* RCA 5 Level */}
            {isRca == 'no' ? (
             <>
            {match.params.status == 3 &&
             <>
             {addItem === 1 ? (
              <>
              {levelInput.map((x, i) => {
              return (
                <>
                <div className="form-group row" key={i}>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                  <DropDownInput
                    data={equipments.equipments}
                    label='Equipment'
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      //setEqpmnt(val.id);
                      handleInputLevel(val, 'equipment_id',i);
                      handleEquipmentChange(val.id,i);
                    }}
                    value={x.equipment_id_name}
                    isStarRequired={true}
                  />
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <DropDownInput
                      data={equipments.issues}
                      label='Issue'
                      required
                      errorMsg={localization.requiredName}
                      getIdValue={(val) => {
                        //setIssue(val.id);
                        handleInputLevel(val, 'issue_id',i);
                        handleLevelChange(val.id,'l1',i);
                        handleTargetLevels('issue',i);
                      }}
                      value={x.issue_id_name}
                      isStarRequired={true}
                    />
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <DropDownInput
                      data={componantData[i]}
                      label='Component'
                      required
                      errorMsg={localization.requiredName}
                      getIdValue={(val) => {
                        handleInputLevel(val, 'componant_id',i);
                        handleLevelChange(val.id,'l1',i);
                        handleTargetLevels('componant',i);
                      }}
                      value={x.componant_id_name}
                      isStarRequired={true}
                    />
                  </div>
                  {/* {console.log(level1Data[i].length)}   */}
                  {((level1Data[i] && level1Data[i].length > 0) || (isEdit == 1 && x?.level_1_name)) && x.componant_id &&
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                        data={level1Data[i]}
                        label='Level 1'
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          handleInputLevel(val, 'level_1',i);
                          handleLevelChange(val.id,'l2',i);
                        }}
                        value={x.level_1_name}
                        isStarRequired={true}
                      />
                    </div>
                  }
                  {((level2Data[i] && level2Data[i].length > 0) || (isEdit == 1 && x?.level_2_name)) && x.level_1 &&
                  <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                        data={level2Data[i]}
                        label='Level 2'
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          handleInputLevel(val, 'level_2',i);
                          handleLevelChange(val.id,'l3',i);
                        }}
                        value={x.level_2_name}
                        isStarRequired={true}
                      />
                    </div>
                  }
                  {((level3Data[i] && level3Data[i].length > 0) || (isEdit == 1 && x?.level_3_name)) && x.level_2 &&
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                        data={level3Data[i]}
                        label='Level 3'
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          handleInputLevel(val, 'level_3',i);
                          handleLevelChange(val.id,'l4',i);
                        }}
                        value={x.level_3_name}
                        isStarRequired={true}
                      />
                    </div>
                  }
                  {((level4Data[i] && level4Data[i].length > 0) || (isEdit == 1 && x?.level_4_name))  && x.level_3 &&
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                        data={level4Data[i]}
                        label='Level 4'
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          handleInputLevel(val, 'level_4',i);
                          handleLevelChange(val.id,'l5',i);
                        }}
                        value={x.level_4_name}
                        isStarRequired={true}
                      />
                    </div>
                  }
                  {((level5Data[i] && level5Data[i].length > 0) || (isEdit == 1 && x?.level_5_name)) && x.level_4 &&
                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <DropDownInput
                        data={level5Data[i]}
                        label='Level 5'
                        required
                        errorMsg={localization.requiredName}
                        getIdValue={(val) => {
                          handleInputLevel(val, 'level_5',i);
                        }}
                        value={x.level_5_name}
                        isStarRequired={true}
                      />
                    </div>
                  }
                  <div className="col-md-6 col-sm-12 col-xs-12">
                  <ConstantInput
                      label='Remarks'
                      type="text"
                      handleChange={(e) =>
                        handleInputLevel(e, 'remark_val',i)
                      }
                      value={x.remark_val}
                      required
                      isStarRequired={true}
                    />
                    </div>

                  {levelInput.length !== 1 &&
                    <div className="col-md-2 col-sm-5">
                        <button
                        onClick={() => handleLevelRemoveClick(i)}
                        className="mr10 btn btn-sm btn-danger">Remove</button>
                        </div>
                        }
                        {levelInput.length - 1 === i &&
                        <div className="col-md-2 col-sm-5">
                        <button className="btn btn-sm btn-primary" onClick={handleLevelAddClick}>Add</button>
                    </div>
                  }
                  </div>

                </>
                );

              })}
              </>
              ) : (addItem === 2) ?
             {}
             : null}
             </>
            }
            </>
            ):null}
            {/* RCA 5 LEVEL */}

            </div>
            {match?.params?.status == 3 && happyCodeCheck &&
              <>
              <div className="col-md-6 col-sm-12 col-xs-12">
                <ConstantInput
                    label='Enter 6 digit OTP'
                    type="number"
                    max={6}
                    maxLength={6}
                    value={remarkData.otp}
                    handleChange={(val) =>
                      setRemarkData({ ...remarkData, otp: val })
                    }
                    required
                    isStarRequired={true}
                />
              </div>
              <div className="form-group col-10">
              <a className={`resend-otp`} onClick={() => {resendOTP()}}>{'Resend OTP'}</a>
             </div>
             </> 
            }
            

            <div className="form-group col-10">

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  saveReply();
                }}
              >
               {'Close'} <img src={Images?.ArrowRight} alt="" />
              </button>
            </div>
          </form>
        </CardSection>
      ):
      <a className="btn btn-primary" href={`/dashboard/rm-tickets`}>{'Already Closed! Go To Ticket'}</a>
      }



      <ModalPop
        title={localization.conf}
        show={successModal}

      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Closed !</h5>
          {match.params.status == 5 ?
          <a class="btn btn-primary" href={`/dashboard/approvals/rm-tickets`}>{'Go To Ticket'}</a>
          :
            (isEdit == 1 ?
              <a className="btn btn-primary" href={`/dashboard/approvals/rm-tickets`}>{'Go To Ticket'}</a>
            :
            <a class="btn btn-primary" href={`/dashboard/rm-tickets`}>{'Go To Ticket'}</a>)
          }
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};

export default CloseRmTicket;
